import React from 'react';

const DropZoneDeleteIcon = () => {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.6665 2.91667H8.33317M4.1665 4.58333V7.08333M5.83317 4.58333V7.08333M2.08317 2.91667L2.49984 7.91667C2.49984 8.13768 2.58763 8.34964 2.74391 8.50592C2.9002 8.6622 3.11216 8.75 3.33317 8.75H6.6665C6.88752 8.75 7.09948 8.6622 7.25576 8.50592C7.41204 8.34964 7.49984 8.13768 7.49984 7.91667L7.9165 2.91667M3.74984 2.91667V1.66667C3.74984 1.55616 3.79374 1.45018 3.87188 1.37204C3.95002 1.2939 4.056 1.25 4.1665 1.25H5.83317C5.94368 1.25 6.04966 1.2939 6.1278 1.37204C6.20594 1.45018 6.24984 1.55616 6.24984 1.66667V2.91667"
        stroke="#444444"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DropZoneDeleteIcon;